<template>
  <div class="overflow-x justify-content-center mt-5">
      <div class=" p-list-representation-table-main">
        <table class="table table-bordered p-table">
            <thead>
              <tr>
                <th >شماره تماس ثبت کننده</th>
                <th >تاریخ ثبت </th>
                <th >نام سالن</th>
                <th >استان/شهر</th>
                <th >وضعیت</th>
                <th >موبایل</th>
                <th ></th>

              </tr>
            </thead>
            <tbody>

              <template v-for="data in tableData">
                  <tr>
                    <th scope="row">{{data.mobile}}</th>
                    <td>{{data.dateConvertedJali}} </td>
                    <td>{{data.sans.hall.name}} </td>
                    <td>{{data.sans.hall.club.location_text}}</td>
                    <td>
                      <div v-if="data.content_approval == 'declined' ">رد</div>
                      <div v-if="data.content_approval == 'approved' ">تایید</div>
                      <div v-if="data.content_approval == 'pending' ">بررسی نشده</div>
                    </td>
                    <td>{{data.mobile}}</td>
                    <td>
                        <div class="d-flex justify-content-end flex-column">
                                <div class="row w-100 mb-2 justify-content-center">
                                  <button @click="accept(data)" type="button" class="btn btn-primary btn-blue btn-sm ml-2 btn-table ">
                                    تایید
                                  </button>
                                  <button @click="rejection(data)" type="button" class="btn btn-primary btn-blue btn-sm btn-table ">
                                    رد
                                  </button>
                                </div>
                        </div>
                    </td>

                  </tr>
                  <tr>
                      <td colspan="9">
                        <div class="d-flex align-items-center">
                            <h3 class="p-table-content-right">متن نظر :</h3>
                            <p class="mb-0 mt-0 p-table-content-left">
                              {{data.content}}
                            </p>
                        </div>
                      </td>
                  </tr>
              </template>



            </tbody>
          </table>
          <div class="d-flex justify-content-center p-table">
            <pagination v-model="valuePage" :per-page="20" :records="500" @paginate="changePage"/>
          </div>
      </div>

  </div>
</template>

<script>
import addCama from '../../modules/addCama.js'


export default {
    name: 'tableContent',
    props: {
      page      : { type: Number, default: 0 },
      tableData : { type: [Object,Array], default: []},
    },

    data() {
      return {
        valuePage : 1,
      }
    },

    computed: {

    },

    mounted () {
      this.valuePage = this.page;
    },

    watch: {
      page(data){
        this.valuePage = this.page;
      },
    },

    methods: {
      accept(data){
        this.$emit('acceptTableItem',data);
      },

      rejection(data){
        this.$emit('rejectionTableItem',data);
      },

      changePage(page){
        this.$emit('paganationChangePage',page)
      }


    },

}
</script>
